/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.shareModule', ['badwing.autoselect', 'mm.foundation', 'restangular', 'bulbApp.busyModule',
  'bulbApp.configModule'])

  .constant('SHARE', {
    FACEBOOK: 'facebook',
    LINKED_IN: 'linkedin',
    TWITTER: 'twitter',
    GENERATED_LINK: 'generated link',
    EMAIL: 'email',
    GOOGLE_CLASSROOM: 'google classroom',
  });
